import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import LanguageSelector from './LanguageSelector';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Header({ variant = 'default', onOpenMobileMenu = null, showMobileMenuButton = false }) {
  const location = useLocation();
  const isLandingPage = location.pathname === '/';

  // Si on est sur la landing page, le logo mène à edomatch.com
  // Sinon, il mène à la landing page du CV builder
  const handleLogoClick = (e) => {
    if (isLandingPage) {
      e.preventDefault();
      window.location.href = 'https://edomatch.com';
    }
  };

  return (
    <header className="bg-[#081B19] text-white sticky top-0 z-50 shadow-lg" data-testid="header">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14">
          {/* Left - Empty spacer or mobile menu button */}
          <div className="w-10 sm:w-24 flex justify-start">
            {showMobileMenuButton && onOpenMobileMenu && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onOpenMobileMenu}
                className="lg:hidden text-white hover:bg-white/10 h-9 w-9"
                data-testid="mobile-menu-btn"
              >
                <Menu className="w-5 h-5" />
              </Button>
            )}
          </div>
          
          {/* Logo - Center */}
          <Link 
            to={isLandingPage ? "#" : "/"} 
            onClick={handleLogoClick}
            className="flex items-center gap-2 hover:opacity-90 transition-opacity" 
            data-testid="logo-link"
          >
            <img 
              src="/favicon-edomatch.png" 
              alt="EdoMatch" 
              className="h-7 w-7 sm:h-8 sm:w-8 object-contain"
            />
            <span className="text-lg sm:text-xl font-bold tracking-wide text-white">EDOMATCH</span>
          </Link>
          
          {/* Language Selector - Right */}
          <div className="w-10 sm:w-24 flex justify-end">
            <LanguageSelector variant="dark" />
          </div>
        </div>
      </div>
    </header>
  );
}
